<script lang="ts">
	import CtaSection from '$lib/sections/cta-section';
	import FeatureSection from '$lib/sections/feature-section';
	import HeroSection from '$lib/sections/hero-section';
	import MeekoGuiSection from '$lib/sections/meeko-gui-section';
	import MeekoPlusSection from '$lib/sections/meeko-plus-section';
	import PricingSection from '$lib/sections/pricing-section';
	import TestimonialsSection from '$lib/sections/testimonials-section';
	import Header from '$lib/components/header/header.svelte';
	import { dev } from '$app/environment';
	import Footer from '$lib/components/footer/footer.svelte';
</script>

<svelte:head>
	<title>Meeko.ai | Your 24/7 AI Coach for LoL</title>
	<meta
		name="description"
		content="Meet Meeko, your new AI Coach for League of Legends. Receive personalized coaching, draft suggestions, matchup advice and more. Available 24/7 on Discord, Windows and macOS."
	/>
	<meta property="og:image" content="https://meeko.ai/images/og.png" />
	<meta property="og:image:width" content="1500" />
	<meta property="og:image:height" content="500" />
	<meta property="og:type" content="website" />
	<meta property="og:title" content="Meeko.ai | Your 24/7 AI Coach for LoL" />
	<meta
		property="og:description"
		content="Meet Meeko, your new AI Coach for League of Legends. Receive personalized coaching, draft suggestions, matchup advice and more. Available 24/7 on Discord, Windows and macOS."
	/>
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:image" content="https://meeko.ai/images/og.png" />
	<meta name="twitter:title" content="Meeko.ai | Your 24/7 AI Coach for LoL" />
	<meta
		name="twitter:description"
		content="Meet Meeko, your new AI Coach for League of Legends. Receive personalized coaching, draft suggestions, matchup advice and more. Available 24/7 on Discord, Windows and macOS."
	/>

	{#if !dev}
		<script
			type="text/plain"
			data-category="analytics"
			data-service="Tolt"
			async
			src="https://cdn.tolt.io/tolt.js"
			data-tolt="47dcb5d0-f43a-4385-aab8-ca8539c0eb7d"
		></script>
	{/if}
</svelte:head>

<Header />
<div class="h-full w-full overflow-x-hidden">
	<HeroSection />
	<MeekoGuiSection />
	<FeatureSection />
	<TestimonialsSection />
	<MeekoPlusSection />
	<PricingSection />
	<CtaSection />
</div>
<Footer />
